import React from 'react';
import { Play } from 'lucide-react';
import type { ExtendedPost } from '../../types/index';
import { Button } from '../ui/button';
import { demoFeedData } from '../../utils/demoFeedData';

interface VideosCarouselProps {
  videos?: ExtendedPost[];
  title?: string;
}

const VideosCarousel: React.FC<VideosCarouselProps> = ({ 
  videos = demoFeedData.sampleVideoPostsData, 
  title = "Popular Videos" 
}) => {
  if (!videos || videos.length === 0) {
    return null;
  }

  const handleViewMore = () => {
    console.log(`View More clicked for: ${title}`);
    // Future: Navigate to the full videos page or section
  };

  return (
    <div className="mb-4">
      <div className="flex justify-between items-center mb-2 px-4">
        <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300">
          {title}
        </h3>
        <Button variant="link" size="sm" onClick={handleViewMore} className="text-xs">
          View More
        </Button>
      </div>
      <div className="flex overflow-x-auto hide-scrollbar gap-3 px-4">
        {videos.map(video => (
          <div key={video.id} className="min-w-[200px] max-w-[200px]">
            <div className="aspect-video bg-gray-200 rounded-lg overflow-hidden relative group cursor-pointer">
              <img
                src={video.media_url ? `${video.media_url}#t=0.1` : 'https://cdn.pixabay.com/photo/2016/02/01/00/56/news-1172463_1280.jpg'}
                alt={video.caption || 'Video thumbnail'}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                onError={(e) => {
                  // Fallback to a default video thumbnail if the video thumbnail fails
                  (e.target as HTMLImageElement).src = 'https://cdn.pixabay.com/photo/2016/02/01/00/56/news-1172463_1280.jpg';
                }}
              />
              <div className="absolute inset-0 bg-black bg-opacity-20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <Play className="w-10 h-10 text-white" />
              </div>
            </div>
            <p className="text-sm font-medium mt-1 truncate dark:text-white">{video.caption || 'Video Title'}</p>
            <p className="text-xs text-gray-500 dark:text-gray-400 truncate">@{video.users.username}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VideosCarousel;
